type InputFieldProps = {
  value: string;
  placeholder: string;
  onChange: (value: string) => void;
  onEnter?: () => void;
  maxLength?: number;
  error?: string;
};

export const InputField: React.FC<InputFieldProps> = ({
  value,
  onChange,
  onEnter,
  placeholder,
  maxLength,
  error,
}) => (
  <div className="flex flex-col gap-y-1">
    <input
      className="w-full px-3 text-white border rounded-lg outline-hidden touch-device:text-sm bg-black/80 touch-device:bg-white/5 placeholder:text-secondary border-white/10 py-2"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      maxLength={maxLength}
      onKeyDown={(e) => {
        if (e.key === "Escape") {
          onChange("");
          e.currentTarget.blur();
        } else if (e.key === "Enter") {
          e.preventDefault();
          onEnter?.();
        }
      }}
    />
    {(error || maxLength) && (
      <div className="flex flex-row justify-between">
        {error && <span className="text-red-500 text-xs">{error}</span>}
        {maxLength && (
          <div className="text-right text-sm text-gray-500 ml-auto">
            {value.length}/{maxLength} characters
          </div>
        )}
      </div>
    )}
  </div>
);
